<ion-content>
	<ion-list>
		<ion-item
			class="option-selected font-medium text-sm"
			*ngFor="let option of optionList"
			(click)="onSelectAction(option)"
			[button]="true"
			[detail]="false"
			>{{ option }}
		</ion-item>
	</ion-list>
</ion-content>
